import { WarningBanner, ErrorBanner } from 'ui/banner';
import styled from 'styled-components';
import { Spinner } from 'ui/spinner';
import { body2, colors, spacing } from 'ui/theme';
import { ModalBody } from 'ui/modal';

export const ChangelogContainer = styled.div`
  border-radius: ${spacing.quarter};
  border: 1px solid ${colors.grey25};
  max-height: 200px;
  overflow-y: auto;
`;

export const StyledWarningBanner = styled(WarningBanner)`
  margin-top: ${spacing.base};
`;

export const StyledErrorBanner = styled(ErrorBanner)`
  margin: ${spacing.half};
`;

export const StyledSpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${colors.grey50};
`;

export const StyledSpinner = styled(Spinner)`
  margin: ${spacing.half};
`;

export const RetryLink = styled.span`
  margin-left: ${spacing.base};
  cursor: pointer;
  text-decoration: underline;
`;

export const NoResults = styled.div`
  ${body2};
  color: ${colors.grey25};
  padding: ${spacing.threeQuarter};
  box-sizing: border-box;
`;

export const StyledModalBody = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;
